import React, { useState } from "react";
import { StaticImage } from "gatsby-plugin-image";
import PropTypes from "prop-types";
import { useInView } from "react-intersection-observer";

// components
import TeamMemberCard from "../TeamMemberCard";
import BioModal from "../BioModal";

// data
import { memberDetails } from "../MemberDetails";

// styles
import * as styles from "./BoardOfDirectors.module.css";

const teamDetails = [
  {
    id: "jahangir-mohammed",
    drName: "Jahangir Mohammed",
    designation: "Founder/Global CEO",
    company: "Twin Health",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/jahangir_v2.png"
        alt="Jahangir Mohammed"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
  {
    id: "toby-cosgrove-md",
    drName: "Toby Cosgrove, MD",
    designation: "Former CEO",
    company: "Cleveland Clinic",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/toby_v2.png"
        alt="Toby Cosgrove"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
  {
    id: "mohit-bhatnagar",
    drName: "Mohit Bhatnagar",
    designation: "Managing Director",
    company: "Sequoia India",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/mohit_v2.png"
        alt="Mohit Bhatnagar"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
  {
    id: "caroline-xie",
    drName: "Caroline Xie",
    designation: "General Partner",
    company: "ICONIQ",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/xie_v2.png"
        alt="Caroline Xie"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
  {
    id: "bruce-dunlevie",
    drName: "Bruce Dunlevie",
    designation: "Founder/General Partner",
    company: "Benchmark Capital",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/bruce_v2.png"
        alt="Bruce Dunlevie"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
  {
    id: "kevin-johnson",
    drName: "Kevin Johnson",
    designation: "Former CEO/President",
    company: "Starbucks",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/kevin_v2.png"
        alt="Kevin Johnson"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
  {
    id: "ravi-lambah",
    drName: "Ravi Lambah",
    designation: "Head, Strategic Initiatives",
    company: "Temasek",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/ravi-lambah.png"
        alt="Ravi Lambah"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
];

const BoardOfDirectors = ({
  title = "Board of Directors",
  members = teamDetails,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const handleReadBio = member => {
    // Find full member details from memberDetails
    const fullMemberData = memberDetails.find(m => m.id === member.id);

    if (fullMemberData) {
      setSelectedMember(fullMemberData);
      setShowModal(true);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedMember(null);
  };

  return (
    <>
      <section className={styles.boardSection}>
        <div
          className={`container scroll_animate ${inView && "inview"}`}
          ref={ref}
        >
          {/* Heading */}
          <div className="row">
            <div className="col-12">
              <h2 className={styles.sectionTitle}>{title}</h2>
            </div>
          </div>

          {/* Team Members Grid */}
          <div className={`row ${styles.teamGrid}`}>
            {members.map((member, index) => (
              <div key={index} className="col-6 col-md-6 col-lg-4">
                <TeamMemberCard member={member} onReadBio={handleReadBio} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Bio Modal */}
      <BioModal
        show={showModal}
        onHide={handleCloseModal}
        member={selectedMember}
      />
    </>
  );
};

BoardOfDirectors.propTypes = {
  title: PropTypes.string,
  members: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      drName: PropTypes.string.isRequired,
      designation: PropTypes.string.isRequired,
      company: PropTypes.string,
      drImage: PropTypes.node.isRequired,
    })
  ),
};

export default BoardOfDirectors;
